import React, { useState, useEffect, useCallback, useMemo } from "react";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import AssignmentIcon from '@mui/icons-material/Assignment';
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import morningbreakfasticon from "../../../../assests/morning-breakfast-items.svg";
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LinkIcon from '@mui/icons-material/Link';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import noRuleicon from "../../../../assests/noruleicon.svg";
import linkedcohorticon from "../../../../assests/linkedcohorticon.svg";
import "./WarehouseAssortmentCreationComponent.css";
import assortmentDetails from "../../../../assests/assortmentdetails.svg";
import { useNavigate, useParams } from "react-router-dom";
import noRuleFound from "../../../..//assests/noRuleFound.svg";
import LoadingSpinner from "../../../Loading/component";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import brandicon from "../../../../assests/brandicon.svg";
import mvidicon from "../../../../assests/mvidicon.svg";
import offerpriceicon from "../../../../assests/offerpriceicon.svg";
import producticon from "../../../../assests/producticon.svg";
import varianticon from "../../../../assests/varianticon.svg";
import Assortment from "../../../../assests/assortment.svg";

const WarehouseAssortmentCreationComponent = (props) => {
  const navigate = useNavigate();
  const { reference_id } = useParams();
  const [userRole, setUserRole] = useState("");
  const [selectedMainTab, setSelectedMainTab] = useState("active");
  const [showFailRulesModal, setShowFailRulesModal] = useState(false);
  const [selectedCohortFails, setSelectedCohortFails] = useState([]);
  const [selectedCohortName, setSelectedCohortName] = useState("");
  const [expandedFailures, setExpandedFailures] = useState({});
  const [showMachinesModal, setShowMachinesModal] = useState(false);
  const [selectedHardwareType, setSelectedHardwareType] = useState(null);
  const [machineSearchTerm, setMachineSearchTerm] = useState("");

  // New state for assortment IDs popup
  const [showAssortmentIdsModal, setShowAssortmentIdsModal] = useState(false);
  const [selectedAssortmentIds, setSelectedAssortmentIds] = useState([]);
  const [selectedRuleInfo, setSelectedRuleInfo] = useState(null);

  // New state for product names popup
  const [showProductNamesModal, setShowProductNamesModal] = useState(false);
  const [selectedProductNames, setSelectedProductNames] = useState([]);
  const [selectedRuleProductInfo, setSelectedRuleProductInfo] = useState(null);

  // Get warehouse metadata
  const warehouseMetadata = props.assortmentWarehouseMetaDataDetails || {};
  const warehouseName = warehouseMetadata.reference_name || "WH Noida";
  const totalMappedVM = warehouseMetadata.total_machines || 0;

  // Calculate total linked VM from cohorts
  const totalLinkedVM = props.linkedWarehouseData?.reduce((sum, cohort) =>
    sum + (cohort.machineCount || 0), 0) || 0;

  // Get assortment data
  const assortmentData = props.assortmentWarehouseMetaDataDetailsList || { active: [], scheduled: [], inactive: [] };

  // Get rule data - structure from API response
  const ruleData = props.assortmentWarehouseMetaDataRuleDetailsList || { active: [], scheduled: [], inactive: [] };

  // Get linked cohorts data
  const linkedCohorts = props.linkedWarehouseData || [];

  const getImageUrl = (path) => path ? `https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/${path}` : null;

  // Get current data based on selected tab
  const getCurrentAssortments = () => {
    switch (selectedMainTab) {
      case "active":
        return assortmentData.active || [];
      case "scheduled":
        return assortmentData.scheduled || [];
      case "inactive":
        return assortmentData.inactive || [];
      default:
        return [];
    }
  };

  const getCurrentRules = () => {
    switch (selectedMainTab) {
      case "active":
        return ruleData.active || [];
      case "scheduled":
        return ruleData.scheduled || [];
      case "inactive":
        return ruleData.inactive || [];
      default:
        return [];
    }
  };

  const handleCloneAssortment = (assortmentId) => {
    navigate(`/home/assortment/clone/${assortmentId}`);
  };

  const handleCreateNewAssortment = () => {
    navigate(`/home/assortment/newassortmentwarehousecreation/${reference_id}`);
  };

  const currentAssortments = getCurrentAssortments();
  const currentRules = getCurrentRules();

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("data"));
    if (userData) {
      setUserRole(userData.details.userRole.role_name);
    }
  }, []);

  // Get active assortment ID for clone button
  const getActiveAssortmentId = () => {
    const activeAssortments = currentAssortments;
    return activeAssortments.length > 0 ? activeAssortments[0].assortmentId : null;
  };

  // Get unique hardware types with counts
  const hardwareTypesWithCounts = useMemo(() => {
    if (!props.assortmentWarehouseMachinesDetailsList) return [];

    return props.assortmentWarehouseMachinesDetailsList.map(hw => ({
      id: hw.hardwareTypeId,
      name: hw.hardwareTypeName,
      count: hw.machineDetails?.length || 0,
      machines: hw.machineDetails || []
    }));
  }, [props.assortmentWarehouseMachinesDetailsList]);

  // Filter machines for modal
  const getFilteredMachines = useMemo(() => {
    let machinesToFilter = [];

    if (selectedHardwareType) {
      const selectedHardware = hardwareTypesWithCounts.find(
        hw => hw.id === selectedHardwareType
      );
      machinesToFilter = selectedHardware?.machines || [];
    } else if (hardwareTypesWithCounts.length > 0) {
      machinesToFilter = hardwareTypesWithCounts.flatMap(hw => hw.machines);
    }

    if (!machineSearchTerm || machineSearchTerm.trim() === "") {
      return machinesToFilter;
    }

    const searchTermLower = machineSearchTerm.toLowerCase().trim();
    return machinesToFilter.filter(machine =>
      (machine.name && machine.name.toLowerCase().includes(searchTermLower)) ||
      (machine.id && machine.id.toString().toLowerCase().includes(searchTermLower))
    );
  }, [hardwareTypesWithCounts, selectedHardwareType, machineSearchTerm]);

  // Updated handleAssortmentDetails to include cohort reference_id
  const handleAssortmentDetails = (assortmentId, cohortId) => {
    if (cohortId) {
      // If cohortId is provided, navigate to cohort assortment details
      navigate(`/home/assortment/assortmentcohortlistdetails/${cohortId}`);
    } else if (reference_id) {
      // If reference_id exists in URL, navigate with that
      navigate(`/home/assortment/assortmentdetails/${assortmentId}/${reference_id}`);
    } else {
      // Default navigation without cohort
      navigate(`/home/assortment/assortmentdetails/${assortmentId}`);
    }
  };

  const handleCohortFailClick = (fails, cohortName) => {
    if (fails && fails.length > 0) {
      setSelectedCohortFails(fails);
      setSelectedCohortName(cohortName || "Unknown Cohort");
      setExpandedFailures({});
      setShowFailRulesModal(true);
    }
  };

  const toggleFailureExpand = (index) => {
    setExpandedFailures(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const handleTotalMappedVMClick = () => {
    setShowMachinesModal(true);
    setMachineSearchTerm("");
    // Set first hardware type as default if available
    if (hardwareTypesWithCounts.length > 0) {
      setSelectedHardwareType(hardwareTypesWithCounts[0].id);
    } else {
      setSelectedHardwareType(null);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setMachineSearchTerm(value);
  };

  const handleHardwareTypeSelect = (hardwareId) => {
    setSelectedHardwareType(hardwareId);
    setMachineSearchTerm("");
  };

  // Handle showing assortment IDs modal
  const handleShowAssortmentIds = (assortmentIds, ruleInfo) => {
    if (assortmentIds && assortmentIds.length > 0) {
      setSelectedAssortmentIds(assortmentIds);
      setSelectedRuleInfo(ruleInfo);
      setShowAssortmentIdsModal(true);
    }
  };

  // Handle showing product names modal
  const handleShowProductNames = (productNames, ruleInfo) => {
    if (productNames && productNames.length > 0) {
      setSelectedProductNames(productNames);
      setSelectedRuleProductInfo(ruleInfo);
      setShowProductNamesModal(true);
    }
  };

  // Parse assortment IDs from string
  const parseAssortmentIds = (assortmentIdsStr) => {
    if (!assortmentIdsStr) return [];
    return assortmentIdsStr.split(',').map(id => id.trim()).filter(id => id);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const formatRuleType = (ruleType) => {
    switch (ruleType) {
      case "MANUFACTURER_VARIANT":
        return "MVID";
      case "OFFER_PRICE":
        return "Offer Price";
      case "BRAND":
        return "Brand";
      case "VARIANT":
        return "Variant";
      case "PRODUCT":
        return "Product";
      default:
        return ruleType || "N/A";
    }
  };

  // Get icon based on rule type
  const getRuleTypeIcon = (ruleType) => {
    switch (ruleType) {
      case "MANUFACTURER_VARIANT":
        return <img src={mvidicon} className="wh-rule-type-icon" alt="MVID" />;
      case "OFFER_PRICE":
        return <img src={offerpriceicon} className="wh-rule-type-icon" alt="Offer Price" />;
      case "BRAND":
        return <img src={brandicon} className="wh-rule-type-icon" alt="Brand" />;
      case "VARIANT":
        return <img src={varianticon} className="wh-rule-type-icon" alt="Variant" />;
      case "PRODUCT":
        return <img src={producticon} className="wh-rule-type-icon" alt="Product" />;
      default:
        return <RuleFolderIcon className="wh-rule-type-icon" />;
    }
  };

  const getProductName = (rule) => {
    if (rule.name) return rule.name;
    return "N/A";
  };

  const getRuleCondition = useCallback((rule) => {
    if (rule.condition === "restricted") {
      return "Restricted";
    }
    if (rule.condition === "quantity") {
      return "Mandatory";
    }
    return "Mandatory";
  }, []);

  const getSlotValue = (rule) => {
    if (rule.value) return rule.value;
    if (rule.slot) return rule.slot;
    return "01";
  };

  const getConditionColor = (condition) => {
    switch (condition) {
      case "restricted":
        return { color: "#FFF", background: "#FF4A4A" };
      case "quantity":
        return { color: "#FFF", background: "#14AE78" };
      default:
        return { color: "#14AE78", background: "#FFF" };
    }
  };

  const renderAssortmentContent = () => {
    const activeAssortmentId = getActiveAssortmentId();

    return (
      <div className="wh-assortment-section">
        <div className="wh-section-header">
          <div className="wh-title-wrapper">
            <img src={Assortment} className="wh-section-icon" alt="Assortment" />
            <h2 className="wh-section-title">Assortment</h2>
          </div>
          <div className="wh-header-buttons">
            {selectedMainTab === "active" && activeAssortmentId && (
              <button
                className="wh-clone-btn"
                onClick={() => handleCloneAssortment(activeAssortmentId)}
              >
                <ContentCopyIcon className="wh-clone-icon" />
                Clone & Schedule
              </button>
            )}
            {selectedMainTab === "scheduled" && (
              <button
                className="wh-create-new-btn"
                onClick={handleCreateNewAssortment}
              >
                + Create New
              </button>
            )}
          </div>
        </div>

        <div className="wh-assortment-list-container">
          {currentAssortments.length > 0 ? (
            currentAssortments.map((item, index) => {
              const hasRuleFailures = item.ruleFailCount > 0;

              return (
                <div key={item.assortmentId || index} className="wh-assortment-card">
                  <div className="wh-assortment-left">
                    <img src={morningbreakfasticon} alt="assortment" className="wh-assortment-img" />
                    <span className="wh-item-badge">{item.itemCount || item.total_items || 0} Items</span>
                  </div>

                  <div className="wh-assortment-center">
                    <div className="wh-created-info">
                      <span className="wh-created-label">Created by</span>
                      <span className="wh-created-value">{item.createdByName || "N/A"} (User ID: {item.createdBy || "N/A"})</span>
                    </div>

                    <div className="wh-assortment-row">
                      <div className="wh-assortment-col">
                        <span className="wh-label">Assortment Id:</span>
                        <span className="wh-value">{item.assortmentId || item.id || "N/A"}</span>
                      </div>
                      <span className="wh-separator">•</span>
                      <div className="wh-assortment-col">
                        <span className="wh-label">Start Date:</span>
                        <span className="wh-value">{formatDate(item.startDate)}</span>
                      </div>
                      {selectedMainTab === "inactive" && item.endDate && (
                        <>
                          <span className="wh-separator">•</span>
                          <div className="wh-assortment-col">
                            <span className="wh-label">End Date:</span>
                            <span className="wh-value">{formatDate(item.endDate || "N/A")}</span>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="wh-assortment-col">
                      {hasRuleFailures ? (
                        <span className="wh-status-fail">
                          <ErrorIcon style={{ fontSize: "14px" }} /> {item.ruleFailCount} Rule{item.ruleFailCount > 1 ? 's' : ''} Failed
                        </span>
                      ) : (
                        <span className="wh-status-pass">
                          <CheckCircleIcon style={{ fontSize: "14px" }} /> All Rules Pass
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="wh-assortment-right">
                    <button className="wh-view-btn" onClick={() => handleAssortmentDetails(item.assortmentId || item.id)}>
                      <VisibilityIcon />
                      <span className="wh-view-text">View</span>
                    </button>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="wh-empty-state">
              <img src={noRuleFound} className="wh-empty-icon" alt="No assortment" />
              <p>No Assortment Found</p>
              {selectedMainTab === "active" && (
                <>
                  <p className="wh-empty-subtext">Create an assortment from the Schedule section.</p>
                  <button
                    className="wh-switch-btn"
                    onClick={() => setSelectedMainTab("scheduled")}
                  >
                    Switch to Schedule
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

 const renderRulesContent = () => {
  // Group rules by type and condition
  const groupedRules = currentRules.reduce((acc, rule) => {
    const key = `${rule.ruleType}-${rule.condition}`;
    if (!acc[key]) {
      acc[key] = {
        type: rule.ruleType,
        condition: rule.condition,
        createdBy: rule.createdByName || "Unknown",
        createdById: rule.createdBy || "Unknown",
        products: []
      };
    }
    
    acc[key].products.push({
      name: rule.productNames?.[0] || "N/A",
      allProductNames: rule.productNames || [],
      id: rule.ruleTypeIds || "N/A",
      ruleId: rule.ruleId,
      startDate: rule.startDate,
      endDate: rule.endDate,
      slot: getSlotValue(rule),
      status: rule.status || "INACTIVE",
      condition: rule.condition,
      ruleType: rule.ruleType,
      value: rule.value,
      maxOfferPrice: rule.maxOfferPrice,
      ruleFailStatus: rule.ruleFailStatus
    });
    
    return acc;
  }, {});

  // Define rule type display names
  const getRuleTypeDisplay = (ruleType) => {
    switch (ruleType) {
      case "MANUFACTURER_VARIANT":
        return "MVID";
      case "OFFER_PRICE":
        return "Offer Price";
      case "BRAND":
        return "Brand";
      case "VARIANT":
        return "Variant";
      case "PRODUCT":
        return "Product";
      default:
        return ruleType || "N/A";
    }
  };

  // Get display value for Required Slot/Max Offer Price column
  const getSlotOrMaxPrice = (product) => {
    // For OFFER_PRICE rules, show maxOfferPrice
    if (product.ruleType === "OFFER_PRICE") {
      return product.maxOfferPrice ? `₹${product.maxOfferPrice}` : "N/A";
    }
    // For other rules, show value/slot
    return product.value || product.slot || "01";
  };

  return (
    <div className="wh-rules-section">
      <div className="wh-section-header">
        <div className="wh-title-wrapper">
          <img src={noRuleicon} className="wh-section-icon" alt="Rules icon" />
          <h2 className="wh-section-title">Rules</h2>
        </div>
        {selectedMainTab !== "inactive" && (
          <button
            className="wh-create-rule-btn"
            onClick={props.onCreateNewRule}
          >
            + Create Rule
          </button>
        )}
      </div>

      <div className="wh-rules-list-container">
        {Object.values(groupedRules).length > 0 ? (
          Object.values(groupedRules).map((ruleGroup, groupIndex) => {
            const conditionStyle = getConditionColor(ruleGroup.condition);
            const ruleTypeDisplay = getRuleTypeDisplay(ruleGroup.type);
            const ruleTypeIcon = getRuleTypeIcon(ruleGroup.type);
            const ruleCondition = ruleGroup.condition === "restricted" ? "Restricted" : "Mandatory";

            return (
              <div key={groupIndex} className="wh-rule-block">
                <div className="wh-rule-header">
                  <div className="wh-rule-title-section">
                    <div className="wh-rule-type-container">
                      <h3 className="wh-rule-main-title">
                        <span className="wh-type-label">Type: </span>
                        <span className="wh-type-value">
                          {ruleTypeIcon}
                          {ruleTypeDisplay}
                        </span>
                      </h3>
                    </div>
                    <div className="wh-rule-creator-info">
                      Created By {ruleGroup.createdBy} (User ID: {ruleGroup.createdById})
                    </div>
                  </div>
                  <div
                    className="wh-rule-condition-badge"
                    style={{
                      color: conditionStyle.color,
                      background: conditionStyle.background
                    }}
                  >
                    {ruleCondition}
                  </div>
                </div>

                <div className="wh-table-wrapper">
                  <table className="wh-rules-table">
                    <thead>
                      <tr>
                        <th>Product Name</th>
                        <th>ID</th>
                        <th>Rule ID</th>
                        <th>Start Date</th>
                        {selectedMainTab === "inactive" && <th>End Date</th>}
                        <th>
                          {ruleGroup.type === "OFFER_PRICE" ? "Max Offer Price" : "Required Slot"}
                        </th>
                        <th>Status</th>
                        <th>Assortment IDs</th>
                        {selectedMainTab !== "inactive" && <th>Action</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {ruleGroup.products.map((product, productIndex) => {
                        const hasRuleFailed = product.ruleFailStatus?.ruleFailStatus === true;
                        const assortmentIds = product.ruleFailStatus?.assortmentIds || "";
                        const assortmentIdList = parseAssortmentIds(assortmentIds);
                        const showSeeMoreAssortment = assortmentIdList.length > 3;
                        const displayAssortmentIds = showSeeMoreAssortment ? assortmentIdList.slice(0, 3) : assortmentIdList;
                        
                        // Product names handling
                        const productNames = product.allProductNames || [];
                        const showSeeMoreProducts = productNames.length > 3;
                        const displayProductNames = showSeeMoreProducts ? productNames.slice(0, 3) : productNames;
                        
                        return (
                          <tr key={productIndex}>
                            <td className="wh-product-names-cell">
                              {displayProductNames.map((name, idx) => (
                                <span key={idx} className="wh-product-name-badge">{name}</span>
                              ))}
                              {showSeeMoreProducts && (
                                <button 
                                  className="wh-see-more-products-btn"
                                  onClick={() => handleShowProductNames(productNames, {
                                    ruleId: product.ruleId,
                                    ruleName: product.name,
                                    ruleType: ruleGroup.type
                                  })}
                                >
                                  +{productNames.length - 3} more
                                </button>
                              )}
                              {productNames.length === 0 && <span className="wh-no-data">-</span>}
                            </td>
                            <td>
                              <span className="wh-id-badge">{product.id}</span>
                            </td>
                            <td>
                              <span className="wh-rule-id">{product.ruleId}</span>
                            </td>
                            <td>{formatDate(product.startDate)}</td>
                            {selectedMainTab === "inactive" && (
                              <td>{formatDate(product.endDate) || "N/A"}</td>
                            )}
                            <td>
                              <span className={product.ruleType === "OFFER_PRICE" ? "wh-max-price-badge" : "wh-slot-badge"}>
                                {getSlotOrMaxPrice(product)}
                              </span>
                            </td>
                            <td>
                              <span className={hasRuleFailed ? "wh-status-fail" : "wh-status-pass"}>
                                {hasRuleFailed ? "Fail" : "Pass"}
                              </span>
                            </td>
                            <td>
                              {assortmentIdList.length > 0 ? (
                                <div className="wh-assortment-ids-cell">
                                  {displayAssortmentIds.map((id, idx) => (
                                    <span key={idx} className="wh-assortment-id-badge">{id}</span>
                                  ))}
                                  {showSeeMoreAssortment && (
                                    <button 
                                      className="wh-see-more-btn"
                                      onClick={() => handleShowAssortmentIds(assortmentIdList, {
                                        ruleId: product.ruleId,
                                        ruleName: product.name,
                                        ruleType: ruleGroup.type
                                      })}
                                    >
                                      +{assortmentIdList.length - 3} more
                                    </button>
                                  )}
                                </div>
                              ) : (
                                <span className="wh-no-ids">-</span>
                              )}
                            </td>
                            {selectedMainTab !== "inactive" && (
                              <td>
                                <button 
                                  className="wh-delete-action"
                                  onClick={() => props.onAssortmentRuleRemove && props.onAssortmentRuleRemove(product.ruleId)}
                                >
                                  ✖
                                </button>
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })
        ) : (
          <div className="wh-empty-rules">
            <img src={noRuleFound} className="wh-empty-icon" alt="No rules" />
            <p className="wh-empty-message">No Rules Found</p>
          </div>
        )}
      </div>
    </div>
  );
};

const renderLinkedCohorts = () => {
  if (selectedMainTab === "inactive") return null;

  if (linkedCohorts.length === 0) {
    return (
      <div className="wh-linked-cohorts-section">
        <div className="wh-linked-header">
          <div className="wh-linked-title">
            <img src={linkedcohorticon} className="wh-linked-icon" alt="Linked cohorts" />
            <h3>Linked Cohorts</h3>
          </div>
        </div>
        <div className="wh-cohorts-empty-state">
          <LinkIcon className="wh-empty-icon" />
          <p>No linked cohorts found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="wh-linked-cohorts-section">
      <div className="wh-linked-header">
        <div className="wh-linked-title">
          <img src={linkedcohorticon} className="wh-linked-icon" alt="Linked cohorts" />
          <h3>Linked Cohorts</h3>
        </div>
      </div>

      <div className="wh-cohorts-list-container">
        {linkedCohorts.map((cohort, index) => {
          const hasFailures = cohort.ruleFailCount > 0;
          const cohortId = cohort.cohortId || cohort.id;
          
          return (
            <div key={index} className="wh-cohort-card">
              {/* Header Section - Clickable for navigation with cohort ID */}
              <div 
                className="wh-cohort-header"
                onClick={() => handleAssortmentDetails(cohortId, cohortId)}
                style={{ cursor: 'pointer' }}
              >
                <div className="wh-cohort-header-left">
                  <LocationOnIcon className="wh-location-icon" />
                  <h4 className="wh-cohort-name">{cohort.cohortName || "N/A"}</h4>
                </div>
                <ChevronRightIcon className="warehouse-card-arrow-icon" />
              </div>

              <div className="wh-cohort-details">
                <div className="wh-cohort-stat">
                  <PrecisionManufacturingIcon className="wh-stat-icon" />
                  <span>{cohort.machineCount || 0} Machines</span>
                </div>
                <div className="wh-cohort-stat">
                  <img src={assortmentDetails} className="wh-stat-icon" alt="Assortment" />
                  <span> Matched Assortment {cohort.finalCount || 0}/{cohort.baseCount || 0} </span>
                </div>

                {/* Rule Fail Section - Clickable only when there are failures */}
                {hasFailures ? (
                  <div
                    className="wh-cohort-stat wh-clickable"
                    onClick={() => handleCohortFailClick(cohort.rule_failure_details || [], cohort.cohortName)}
                  >
                    <ErrorIcon className="wh-stat-icon wh-error-icon" />
                    <span>{cohort.ruleFailCount} Rules Need Attention</span>
                    <ChevronRightIcon className="wh-small-arrow" />
                  </div>
                ) : (
                  <div className="wh-cohort-stat">
                    <CheckCircleIcon className="wh-stat-icon wh-success-icon" />
                    <span>All Rules Pass</span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
  // Product Names Modal
  const ProductNamesModal = () => {
    if (!showProductNamesModal) return null;

    return (
      <div className="wh-modal-overlay" onClick={() => setShowProductNamesModal(false)}>
        <div className="wh-modal-container wh-product-names-modal" onClick={(e) => e.stopPropagation()}>
          <div className="wh-modal-header">
            <h3>Product Names</h3>
          </div>

          <div className="wh-modal-body">
            <div className="wh-product-names-grid">
              {selectedProductNames.map((name, index) => (
                <div key={index} className="wh-product-name-item">
                  <span className="wh-product-name-number">{index + 1}.</span>
                  <span className="wh-product-name-value">{name}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="wh-modal-footer">
            <button
              className="wh-ok-btn"
              onClick={() => setShowProductNamesModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Assortment IDs Modal
  const AssortmentIdsModal = () => {
    if (!showAssortmentIdsModal) return null;

    return (
      <div className="wh-modal-overlay" onClick={() => setShowAssortmentIdsModal(false)}>
        <div className="wh-modal-container wh-assortment-ids-modal" onClick={(e) => e.stopPropagation()}>
          <div className="wh-modal-header">
            <h3>Assortment IDs</h3>
            <button className="wh-modal-close" onClick={() => setShowAssortmentIdsModal(false)}>
              <CloseIcon />
            </button>
          </div>

          <div className="wh-modal-body">
            {selectedRuleInfo && (
              <div className="wh-rule-info-summary">
                <p><strong>Rule ID:</strong> {selectedRuleInfo.ruleId}</p>
                <p><strong>Rule Name:</strong> {selectedRuleInfo.ruleName || "N/A"}</p>
                <p><strong>Rule Type:</strong> {formatRuleType(selectedRuleInfo.ruleType)}</p>
              </div>
            )}

            <div className="wh-assortment-ids-grid">
              {selectedAssortmentIds.map((id, index) => (
                <div key={index} className="wh-assortment-id-item">
                  <span className="wh-assortment-id-number">{index + 1}.</span>
                  <span className="wh-assortment-id-value">{id}</span>
                  <button
                    className="wh-view-assortment-btn"
                    onClick={() => handleAssortmentDetails(id)}
                    title="View Assortment Details"
                  >
                    <VisibilityIcon />
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="wh-modal-footer">
            <button
              className="wh-ok-btn"
              onClick={() => setShowAssortmentIdsModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  const FailRulesModal = () => {
    if (!showFailRulesModal) return null;

    return (
      <div className="wh-modal-overlay" onClick={() => setShowFailRulesModal(false)}>
        <div className="wh-modal-container wh-fail-modal" onClick={(e) => e.stopPropagation()}>
          <div className="wh-modal-header">
            <h3>Rules Needing Attention - {selectedCohortName}</h3>
            <button className="wh-modal-close" onClick={() => setShowFailRulesModal(false)}>
              <CloseIcon />
            </button>
          </div>

          <div className="wh-modal-body">
            <div className="wh-fail-list">
              {selectedCohortFails.length > 0 ? (
                selectedCohortFails.map((fail, index) => {
                  const isExpanded = expandedFailures[index];
                  const failureType = fail.failureType || "Unknown";
                  const ruleId = fail.ruleId || "N/A";
                  const failedItems = fail.failedItems || {};
                  const items = failedItems.failRuleItemDetails || [];

                  const createdByName = items[0]?.createdByName || "Bajrang Tiwari";
                  const createdById = items[0]?.createdBy || "992";

                  return (
                    <div key={index} className="wh-fail-item">
                      <div className="wh-fail-item-header" onClick={() => toggleFailureExpand(index)}>
                        <div className="wh-fail-item-summary">
                          <ErrorIcon className="wh-fail-icon" />
                          <div className="wh-fail-content">
                            <div className="wh-fail-rule">
                              {items[0]?.name || "Unknown Product"}
                            </div>
                            <div className="wh-fail-creator">
                              Created By {createdByName} (User ID {createdById})
                            </div>
                          </div>
                        </div>
                        <div className="wh-expand-icon">
                          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </div>
                      </div>

                      <div className="wh-fail-main-table">
                        <table className="wh-fail-main-table-content">
                          <thead>
                            <tr>
                              <th>Rule ID</th>
                              <th>Start Date</th>
                              <th>Type</th>
                              <th>ID</th>
                              <th>Slot Type</th>
                              <th>Required Slot</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td><span className="wh-rule-id">{ruleId}</span></td>
                              <td>{formatDate(fail.startDate) || "N/A"}</td>
                              <td><span className="wh-type-badge">{fail.failureType === "brand_not_present" ? "Variant" : "MVID"}</span></td>
                              <td><span className="wh-id-badge">{items[0]?.id || "N/A"}</span></td>
                              <td><span className="wh-slot-type-badge wh-restricted">Restricted</span></td>
                              <td><span className="wh-slot-badge">{failedItems.value || "01"}</span></td>
                              <td><span className="wh-status-fail">Fail</span></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {isExpanded && (
                        <div className="wh-fail-item-expanded">
                          <div className="wh-expanded-title">Failed Item Details</div>
                          <div className="wh-failed-items-container">
                            <table className="wh-failed-items-table">
                              <thead>
                                <tr>
                                  <th>Product Name</th>
                                  <th>Product ID</th>
                                  <th>Product Image</th>
                                </tr>
                              </thead>
                              <tbody>
                                {items.map((item, idx) => (
                                  <tr key={idx}>
                                    <td>{item.name || "N/A"}</td>
                                    <td><span className="wh-id-badge">{item.id || "N/A"}</span></td>
                                    <td>
                                      {item?.image ? (
                                        <img
                                          src={getImageUrl(item.image)}
                                          alt=""
                                          style={{
                                            width: 40,
                                            height: 40,
                                            objectFit: 'cover',
                                            borderRadius: 4
                                          }}
                                        />
                                      ) : (
                                        <div style={{
                                          width: 40,
                                          height: 40,
                                          background: '#F3F4F6',
                                          borderRadius: 8,
                                          margin: '0 auto'
                                        }}></div>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <div className="wh-fail-item">
                  <div className="wh-fail-item-summary">
                    <ErrorIcon className="wh-fail-icon" />
                    <div className="wh-fail-content">
                      <div className="wh-fail-rule">No failure details available</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="wh-modal-footer">
            <button className="wh-ok-btn" onClick={() => setShowFailRulesModal(false)}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Enhanced Machines Modal with improved UI and fixed search
  const MachinesModal = () => {
    if (!showMachinesModal) return null;

    const totalMachines = getFilteredMachines.length;
    const selectedHardwareName = hardwareTypesWithCounts.find(hw => hw.id === selectedHardwareType)?.name || "All Machines";

    return (
      <div className="wh-modal-overlay" onClick={() => setShowMachinesModal(false)}>
        <div className="wh-modal-container wh-machines-modal" onClick={(e) => e.stopPropagation()}>
          <div className="wh-modal-header">
            <div className="wh-modal-header-content">
              <div>
                <h3>Total Mapped VM</h3>
                <p className="wh-modal-subtitle">{totalMappedVM} machines mapped to this warehouse</p>
              </div>
            </div>
            <button className="wh-modal-close" onClick={() => setShowMachinesModal(false)}>
              <CloseIcon />
            </button>
          </div>

          <div className="wh-modal-body">
            {/* Hardware Type Tabs */}
            {hardwareTypesWithCounts.length > 0 && (
              <div className="wh-hardware-tabs-container">
                <button
                  className={`wh-hardware-tab-main ${!selectedHardwareType ? "active" : ""}`}
                  onClick={() => setSelectedHardwareType(null)}
                >
                  <span className="wh-hardware-tab-name">All Machines</span>
                  <span className="wh-hardware-tab-count">{totalMappedVM}</span>
                </button>
                {hardwareTypesWithCounts.map((hardware) => (
                  <button
                    key={hardware.id}
                    className={`wh-hardware-tab-main ${selectedHardwareType === hardware.id ? "active" : ""}`}
                    onClick={() => handleHardwareTypeSelect(hardware.id)}
                  >
                    <span className="wh-hardware-tab-name">{hardware.name}</span>
                    <span className="wh-hardware-tab-count">{hardware.count}</span>
                  </button>
                ))}
              </div>
            )}

            {/* Search Box */}
            <div className="wh-search-box">
              <input
                type="text"
                placeholder="Search by machine name or ID..."
                value={machineSearchTerm}
                onChange={(e) => setMachineSearchTerm(e.target.value)}
                className="wh-search-input"
                autoFocus
              />
              <span className="wh-search-icon">🔍</span>
              {machineSearchTerm && (
                <button
                  className="wh-clear-search"
                  onClick={() => setMachineSearchTerm("")}
                >
                  <CloseIcon fontSize="small" />
                </button>
              )}
            </div>

            {/* Results Summary */}
            <div className="wh-results-summary">
              <PrecisionManufacturingIcon className="wh-results-icon" />
              <span>
                Showing {totalMachines} machine{totalMachines !== 1 ? 's' : ''}
                {selectedHardwareType && ` in ${selectedHardwareName}`}
                {machineSearchTerm && ` matching "${machineSearchTerm}"`}
              </span>
            </div>

            {/* Machines Table */}
            <div className="wh-table-container">
              {getFilteredMachines.length > 0 ? (
                <table className="wh-vm-table">
                  <thead>
                    <tr>
                      <th className="wh-number-col">#</th>
                      <th className="wh-name-col">Machine Name</th>
                      <th className="wh-id-col">Machine ID</th>
                      </tr>
                    </thead>
                  <tbody>
                    {getFilteredMachines.map((machine, index) => (
                      <tr key={machine.id || index} className="wh-table-row">
                        <td className="wh-number">{index + 1}</td>
                        <td className="wh-name">
                          <div className="wh-machine-name-cell">
                            <span>{machine.name || "N/A"}</span>
                          </div>
                        </td>
                        <td className="wh-id">
                          <span className="wh-machine-id-badge">{machine.id || "N/A"}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="wh-empty-machines">
                  <PrecisionManufacturingIcon className="wh-empty-icon" />
                  <p>No machines found</p>
                  {machineSearchTerm && (
                    <button
                      className="wh-clear-search-btn"
                      onClick={() => setMachineSearchTerm("")}
                    >
                      Clear search
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="wh-modal-footer">
            <button className="wh-ok-btn" onClick={() => setShowMachinesModal(false)}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  const EndRuleConfirmationModal = () => {
    const today = new Date().toISOString().split("T")[0];

    if (!props.showEndRuleModal) return null;

    return (
      <div className="wh-modal-overlay" onClick={props.onCloseEndRuleModal}>
        <div className="wh-modal-container wh-end-rule-modal" onClick={(e) => e.stopPropagation()}>
          <div className="wh-modal-header">
            <h3>Are You Sure You Want To End This Rule?</h3>
            <button className="wh-modal-close" onClick={props.onCloseEndRuleModal}>
              <CloseIcon />
            </button>
          </div>

          <div className="wh-modal-body">
            <div className="wh-field-group">
              <label>Select End Date</label>
              <input
                type="date"
                value={props.endDate}
                onChange={(e) => props.onEndDateChange(e.target.value)}
                className="wh-date-field"
                min={today}
              />
            </div>
          </div>

          <div className="wh-modal-footer">
            <button className="wh-cancel-btn" onClick={props.onCloseEndRuleModal}>
              Cancel
            </button>
            <button
              className="wh-confirm-btn wh-error-btn"
              onClick={props.onEndRuleConfirm}
              disabled={!props.endDate}
            >
              End Rule
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="wh-main-layout">
          <Sidebar />
          <div className="wh-content-area">
            <div className="wh-page-header">
              <button className="wh-back-btn" onClick={() => navigate(-1)}>←</button>
              <div className="wh-header-info">
                <h1 className="wh-page-title">{warehouseName}</h1>
                <div className="wh-stat-badges">
                  <div
                    className="wh-stat-item wh-clickable-stat"
                    onClick={handleTotalMappedVMClick}
                  >
                    <span>Total Mapped VM - {totalMappedVM}</span>
                  </div>
                  <div className="wh-stat-item">
                    <span>Total Linked VM - {totalLinkedVM}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="wh-main-tabs">
              <button
                className={`wh-main-tab tab-active ${selectedMainTab === "active" ? "active-tab-dark" : ""}`}
                onClick={() => setSelectedMainTab("active")}
              >
                Active
              </button>
              <button
                className={`wh-main-tab tab-schedule ${selectedMainTab === "scheduled" ? "active-tab-dark" : ""}`}
                onClick={() => setSelectedMainTab("scheduled")}
              >
                Schedule
              </button>
              <button
                className={`wh-main-tab tab-inactive ${selectedMainTab === "inactive" ? "active-tab-dark" : ""}`}
                onClick={() => setSelectedMainTab("inactive")}
              >
                Inactive
              </button>
            </div>

            <div className="wh-sections-container">
              {renderAssortmentContent()}
              {renderRulesContent()}
              {renderLinkedCohorts()}
            </div>
          </div>
        </div>
      )}
      <EndRuleConfirmationModal />
      <FailRulesModal />
      <MachinesModal />
      <AssortmentIdsModal />
      <ProductNamesModal />
    </>
  );
};

export default WarehouseAssortmentCreationComponent;